export const ENDPOINTS = {
  login: 'api/login',
  logout: 'api/kill_session',
  user: 'api/users/session_userinfo',

  check_invitation_token: 'api/users/invitation/check',
  invitation: 'api/users/invitation',

  check_reset_password_token: 'api/users/reset_password/check',
  reset_password: 'api/users/reset_password',

  oauth_authorize: 'oauth/authorize',

  // Azure AD endpoints
  company_info: 'api/companies',
  azure_login: 'api/auth/azure/login',
  sso_login: 'api/auth/sso/login',
};
